import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { HeaderComponent } from '../components/header/header.component';
import { MaintenanceBannerComponent } from '../components/maintenance-banner/maintenance-banner.component';
import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { loadAuthFromStorage } from '@state/auth/auth.actions';
import { Router } from '@angular/router';
import { StickyHeaderHeightService } from '@core/services/sticky-header-height.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, MaintenanceBannerComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('stickyHeader') stickyHeaderRef!: ElementRef<HTMLDivElement>;

  private resizeObserver?: ResizeObserver;

  get isNoPermissionPage(): boolean {
    return this.router.url.startsWith('/no-permission');
  }

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private stickyHeaderHeightService: StickyHeaderHeightService
  ) {}

  ngOnInit() {
    this.store.dispatch(loadAuthFromStorage());
  }

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(entries => {
      const height = entries[0]?.contentRect.height;

      if (height) this.stickyHeaderHeightService.setHeight(height);
    });

    this.resizeObserver.observe(this.stickyHeaderRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
